import { useState } from 'react';
import axios from '../axios/axios'; //import our local (csurf-ed) instance of axios!!!

export const useFormHook = (callback) => {
	/**
	 * Define a hook to handle all form fields.
	 */
	const [values, setValues] = useState({}); //Define default value for the form fiels.

	const handleSubmit = (e) => {
		/**
		 * Define a callback function to handle the submit action.
		 */
		if (e) e.preventDefault();
		callback();
	};

	const handleChange = (target, value) => {
		/**
		 * Define a function to handle field changes
		 * and update values ​​so that they can be used in the submit form.
		 */
		setValues({
			...values,
			[target]: value,
		});
	};

	return { values, handleSubmit, handleChange }; //return the variables to be used in the React Components.
};

export const useCheckSignIn = (callback) => {
	/**
	 * Define a hook to check user status.
	 */
	const checkUserStatus = () => {
		axios({
			method: 'get',
			url: '/bff/check/check-signin',
		}).then(({ data: { response } }) => callback(response));
	};

	return { checkUserStatus }; //return the variable to be used in the React Component.
};

export const useLogout = () => {
	/**
	 * Define a hook for logout logic.
	 */
	const logout = () => {
		axios({
			method: 'get',
			url: '/bff/logout/user-logout',
		}).then(({ data: { response, microsoftLogoutUrl } }) => {
			if (response) {
				if (microsoftLogoutUrl) {
					window.location.replace(microsoftLogoutUrl);
					return;
				}
				window.location.reload();
			}
		});
	};

	return { logout }; //return the variable to be used in the React Component.
};

export const useRequestHook = () => {
	/**
	 * Define a hook to handle all GET and POST requsts.
	 * Version 2 to test if everything works - DELETE first requestHook!!!!
	 */
	const handleRequest = (
		requestedMethod,
		requestedUrl,
		requestedData,
		returnResponse,
		responseType
	) => {
		/**
		 * Define function for the request logic.
		 */
		let axiosConfig = {
			method: requestedMethod,
			url: '/bff' + requestedUrl,
		}

		if (requestedMethod === 'post') {
			axiosConfig = {
				...axiosConfig,
				data: requestedData
			}
		}

		if (responseType === 'blob') {
			axiosConfig = {
				...axiosConfig,
				responseType
			}
		}
		//Define config object.
		
		axios(axiosConfig)
			.then(({ data }) => {
				/**
				 * Set server response.
				 */
				returnResponse(data.response, data.msg, data);
			})
			.catch((error) => {
				// handle error - redirect to "/"
				console.log(error)
				window.location.replace('/');
			});
	};

	return { handleRequest }; //return the variables to be used in the React Components.
};
